<template>
  <div>
    <div class="flex flex-row border mb-12 p-4 items-center justify-between">
      <p class="font-bold">Upcoming Events - {{ selectedMonthAndYear ? monthToBeDisplayed(selectedMonthAndYear) : "All" }}</p>
      <form class="border p-4">
        <label for="event-months">Select Month <i class="fa-solid fa-calendar-week"></i></label>
        <select name="eventMonths" id="event-months" v-model="selectedMonthAndYear">
          <option value="">All</option>
          <option v-for="entry in createMonthFilterArr()"
                  :value="entry.value">{{entry.label}}</option>
        </select>
      </form>
    </div>
    <div class="grid md:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      <div v-for="entry in eventsToBeDisplayed()" class="bg-gray-light relative">
        <div class="relative">
            <a :href="`/events/${entry.slug}`" class="hover:opacity-80 cursor-pointer" aria-label="{{entry.title}} event link">
              <img :src="entry.image.url" :alt="entry.image.alt  ?  entry.image.alt : 'Carousel Card Image'" class="object-cover w-full aspect-square" />
            </a>
          <div class="absolute top-0 right-0 bg-black text-white h-16 w-16 z-20">
            <div class="absolute inset-0 w-full text-center p-2">
              <p class="uppercase text-xs">{{ getEventMonthToBeDisplayed(entry.date) }}</p>
              <p class="text-2xl">{{ getEventDayToBeDisplayed(entry.date) }}</p>
            </div>
          </div>
        </div>
        <div class="p-8">
          <div class="flex flex-row items-center justify-between mb-8">
            <p class="text-honey font-bold">{{ entry.location ? entry.location : "At Our Farm"}}</p>
          </div>
          <p class="font-bold mb-8">{{ entry.title }}</p>
          <a :href="entry.btn_link" class="btn-honey" target="_blank" v-if="entry.btn_link">{{ entry.btn_text }}</a>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "EventsGrid",
  props:{
    entries: {
      type: Array,
      default: null
    },
    months: {
      type: Array,
      default: [
      {
        filterMonth: "January",
        display: "Jan",
        digit: 1
      },
      {
        filterMonth: "February",
        display: "Feb",
        digit: 2
      },
      {
        filterMonth: "March",
        display: "Mar",
        digit: 3
      },
      {
        filterMonth: "April",
        display: "Apr",
        digit: 4
      },
      {
        filterMonth: "May",
        display: "May",
        digit: 5
      },
      {
        filterMonth: "June",
        display: "Jun",
        digit: 6
      },
      {
        filterMonth: "July",
        display: "Jul",
        digit: 7
      },
      {
        filterMonth: "August",
        display: "Aug",
        digit: 8
      },
      {
        filterMonth: "September",
        display: "Sep",
        digit: 9
      },
      {
        filterMonth: "October",
        display: "Oct",
        digit: 10
      },
      {
        filterMonth: "November",
        display: "Nov",
        digit: 11
      },
      {
        filterMonth: "December",
        display: "Dec",
        digit: 12
      }
      ],
    }
  },
  data(){
    return {
      selectedMonthAndYear: ''
    }

  },
  created() {
    this.getEventMonthToBeDisplayed();
    this.getEventDayToBeDisplayed();
    this.eventsToBeDisplayed();
  },
  computed: {
    futureEvents(){
      // let today = new Date().toISOString();
      // today.setDate(today.getDate() - 1);
      let today = new Date(new Date().setDate(new Date().getDate()-1)).toISOString();

      return this.entries.filter(e => {
            if(e.date >= today){
              return true;
            }});
    },
  },
  methods:{

    eventsToBeDisplayed(){
      let allEvents = this.futureEvents;

      //find all future upcoming events
      let updatedEvents = allEvents.filter((ue)=>{
        if(this.selectedMonthAndYear !== ""){
          return this.slugifyMonth(this.monthToBeDisplayed(ue.date)) === this.selectedMonthAndYear;
        }

        return true;
      });

      //display upcoming events in ascending order
      updatedEvents.reverse();

      return updatedEvents;
    },
    getEventMonthToBeDisplayed(d){
      let date = new Date(d);
      let month = date.getMonth() + 1;
      let monthDisplay;

      this.months.forEach((m) => {
        if(m.digit === month){
          monthDisplay = m.display;
        }
      });

      return monthDisplay;
    },
    getEventDayToBeDisplayed(d){
      let date = new Date(d);

      return date.getDate() ;
    },
    monthToBeDisplayed(m){
      let date = new Date(m);
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let monthDisplay;

      this.months.forEach((m) => {
        if(m.digit === month){
          monthDisplay = m.filterMonth;
        }
      });

      return monthDisplay + ' ' + year;
    },
    slugifyMonth(sm){
      return sm.toLowerCase().replace(/ /g,'-')
    },
    createMonthFilterArr(){
      let allDates = this.futureEvents
          .map((e)=>this.monthToBeDisplayed(e.date));

      allDates.reverse();

      let unique = Array.from(new Set(allDates));

      return unique.map(d => {return {
        label: d,
        value: this.slugifyMonth(d)
      }});
    }
  }
}
</script>

<style scoped>

</style>
